import React from "react";
import PropTypes from "prop-types";
import { Frame } from "@bitesite/react-figstrap";
import { selectionButtonType } from "../common/utilities";
import { Button } from "../../../odc-ui";
import styled from "styled-components/macro";

const TreatmentCategoryButton = styled(Button)`
  text-transform: none;
  width: 100%;
`;

const TreatmentCategorySelection = ({
  caption,
  treatmentCategory,
  onTreatmentCategoryClick,
  theme,
}) => {
  const treatmentCategoryOptions = [
    { label: "Dermatology", value: "dermatology" },
    { label: "Surgery", value: "surgery" },
  ];

  return (
    <Frame vertical gap={10}>
      <div>{caption}</div>
      <div>
        <Frame vertical gap={10}>
          {treatmentCategoryOptions.map((treatmentCategoryOption) => (
            <div key={treatmentCategoryOption.value}>
              <TreatmentCategoryButton
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  onTreatmentCategoryClick(treatmentCategoryOption.value);
                }}
                type={selectionButtonType(
                  theme,
                  treatmentCategory === treatmentCategoryOption.value
                )}
              >
                {treatmentCategoryOption.label}
              </TreatmentCategoryButton>
            </div>
          ))}
        </Frame>
      </div>
    </Frame>
  );
};

TreatmentCategorySelection.propTypes = {
  caption: PropTypes.string.isRequired,
  treatmentCategory: PropTypes.string.isRequired,
  onTreatmentCategoryClick: PropTypes.func.isRequired,
  theme: PropTypes.string,
};

export default TreatmentCategorySelection;
